import React, { useEffect } from 'react'
import { useEffectWithPolling } from 'uxp/components';
import { IWidgetTemplateInstanceProps, IWidgetTemplateProps, registerCardTemplate } from '../../../common/common';
import { DataSourceProperty } from '../../../common/ui-props/DataSourceProperty';
import { createDefaultPropsForWidgetWrapperWithSidebar, WidgetWrapperWithSidebar } from '../../../common/widget-wrappers/WidgetWrapperWithSidebar';
import { BoxChartProperty, IBoxChartProps } from './properties';
import { IContextData, useInitialContextData } from '../../../../hooks/useContextData';
import { RoundOffProperty, roundOffValue } from '../../../common/ui-props/RoundOffProperty';
import WDFilterPanel from '../../../common/components/WDFilterPanel';
import './BoxChart.scss'
import { executeAndBind, processInitialSource } from '../../../common/data-source-picker/datasource';
import { hasValue } from '../../../../util';

let rdKey: any = {};
function generateRandomData(colors: string[], labelField: string, valueField: string) {
    let key = JSON.stringify(colors) + '/' + valueField + '/' + labelField;
    if (!rdKey[key]) {

        let data = colors.map((c, i) => {
            return { name: `Label ${i + 1}`, [valueField]: (Math.round(Math.random() * 100)) }
        });
        rdKey[key] = data;
    }
    return rdKey[key];
}

const XPR: React.ForwardRefExoticComponent<React.RefAttributes<IWidgetTemplateInstanceProps> & IWidgetTemplateProps> = React.forwardRef((props, ref) => {

    const { uiProps, designer, uxpContext } = props

    const [data, setData] = React.useState<any>({})
    const [chartData, setChartData] = React.useState<any[]>([])
    const [initialSource, setIntitialSource] = React.useState(props.initialSource);

    const containerRef = React.useRef(null)


    const defaults: IBoxChartProps = {
        labelField: '',
        valueField: '',
        legend: true,
        colors: ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'],
        refreshInsterval: 30000,
        channel: '',
        useColorsForLabels: false,
        shadow: false,
        barHeight: 100,
        borderRadius: 5,
    }

    React.useImperativeHandle(ref, () => ({
        beforeSave: validateBeforeSave,
        onPreview: validateBeforeSave
    }))

    const { labelField, valueField, legend, colors, refreshInsterval, channel, barHeight, shadow, borderRadius } = uiProps.chartProperty as IBoxChartProps || defaults

    const XPRProps = createDefaultPropsForWidgetWrapperWithSidebar({
        'source': DataSourceProperty('Source', uiProps.source, uiProps.datasources, props.uxpContext, props.designer, 'dictionary-array'),
        'chartProperty': BoxChartProperty('Chart', uiProps.chartProperty || defaults),
        'roundOff': RoundOffProperty({ integer: false, decimalPoints: 2 }, null, true)

    });


    let [contextData, setContextData] = React.useState<IContextData>({})
    const [loading, setLoading] = React.useState(false)

    const { isLoading, initialContextData } = useInitialContextData(props)

    React.useEffect(() => {
        setLoading(isLoading)
        setContextData(prev => ({ ...prev, ...initialContextData }))
    }, [isLoading, initialContextData])

    useEffect(() => {
        processInitialSource(props.designer, props.uxpContext, props.uiProps, initialSource, 'dictionary-array')
            .then(res => {
                if (res) props.designer?.setUIProps(res)
            })
            .catch(e => {
                console.log('exception ', e);

            })
    }, [initialSource])




    useEffectWithPolling(uxpContext, channel || "chart/1", refreshInsterval || 60000, async () => {

        if (props.designer && (props.designer.mode == 'preview' || props.designer.mode == 'thumbnail')) {

            let data = generateRandomData(colors, labelField, valueField);

            setChartData(data)
            return
        }

        executeAndBind(props.uxpContext, uiProps.source, uiProps.datasources, {}, contextData)
            .then(res => {
                console.log("res", res);

                let updated = res.map((r: any) => {
                    return {
                        ...r,
                        name: r[labelField]
                    }
                })

                setChartData(updated)
            })
    }, [designer])

    useEffect(() => {
        console.log('chartdata', chartData);
    }, [chartData])

    function validateBeforeSave() {
        if (!isDataSourceValid()) return false
        if (!hasFieldsConfigured()) return false
        return true
    }

    function isDataSourceValid() {
        if (!hasValue(uiProps?.source) || !hasValue(uiProps.source?.source) || !hasValue(uiProps.source?.path)) {
            props.designer?.addErrors?.([{
                id: 'datasource',
                type: 'property',
                error: 'Data source is required',
                containerId: 'chart-container',
                fieldId: 'source'
            }])
            return false
        }
        props.designer?.removeErrors?.(['datasource'])
        return true
    }

    function hasFieldsConfigured() {
        if (!hasValue(uiProps?.chartProperty?.labelField)) {
            props.designer?.addErrors?.([{
                id: 'label-field',
                type: 'property',
                error: 'Label field is required',
                containerId: 'chart-container',
                fieldId: 'label-field'
            }])
            return false
        }
        props.designer?.removeErrors?.(['label-field'])

        if (!hasValue(uiProps?.chartProperty?.valueField)) {
            props.designer?.addErrors?.([{
                id: 'value-field',
                type: 'property',
                error: 'Value field is required',
                containerId: 'chart-container',
                fieldId: 'value-field'
            }])
            return false
        }
        props.designer?.removeErrors?.(['value-field'])
        return true
    }
    let boxShadow = shadow ? '3px 1px 9px 0px #00000069' : undefined;
    // Calculate the total of chart[value]
    let total = 0;
    chartData.forEach(chart => {
        total += parseInt(chart[valueField], 10);
    });

    return (
        <WidgetWrapperWithSidebar
            className='uxp-custom-box-chart-template'
            contextData={contextData}
            propDef={XPRProps}
            uiProps={uiProps}
            elementId='chart-container'
            designer={props.designer}
            defaultTitle='Box Chart'
            showFilterWithoutFields={true}
            containerRef={containerRef}
            filterSection={() =>
                <WDFilterPanel
                    designer={props.designer}
                    uxpContext={props.uxpContext}
                    uiProps={uiProps}
                    containerRef={containerRef}
                    data={contextData || {}}
                    onChangeFilters={(data) => {
                        setContextData(prev => ({ ...prev, filters: data?.filters || {} }))
                    }}
                    onClearFilters={() => {
                        setContextData(prev => ({ ...prev, filters: {} }))
                    }}
                // onOpenPanel={() => {
                //     // if (props.designer && (props.designer.mode == 'preview' || props.designer.mode == 'thumbnail')) {
                //     //     setDisableDrop(true)
                //     // }
                // }}
                // onClosePanel={() => { setDisableDrop(false) }}
                />
            }>

            <div className="boxChartWrapper">

                <div className="columnContainer" style={{ borderRadius: `${borderRadius}px` }}>
                    {chartData.map((chart, i) => {
                        // Calculate the percentage and handle division by zero
                        const percentage = total === 0 ? 0 : (parseInt(chart[valueField]) / total) * 100;

                        return (
                            <div
                                key={i}
                                style={{
                                    position: "relative",
                                    flex: 1,
                                    height: `${barHeight}px`,
                                    boxShadow,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    zIndex: 1 + chartData.length - i,
                                    width: "100%", // Make the bar fill the entire width
                                    background: colors[i % colors.length],
                                    maxWidth: `${percentage}%`, // Set the width based on percentage
                                }}
                            >
                                <span>{roundOffValue(chart[valueField], uiProps.roundOff)}</span>
                            </div>
                        );
                    })}
                </div>

                <div className="labels">
                    {chartData.map((chart, i) => (
                        <>
                            <p
                                style={{ "--item-color": colors[i % colors.length] } as React.CSSProperties}
                            >
                                {chart.name}
                            </p>
                        </>
                    ))}
                </div>
            </div>

        </WidgetWrapperWithSidebar>
    )
})


registerCardTemplate({
    id: 'box-chart',
    name: 'Box chart',
    description: 'box chart',
    template: XPR,
    icon: <div>
        <svg width="58" height="24" viewBox="0 0 58 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="57" height="23" rx="2.5" fill="#D9D9D9" stroke="#424242" />
            <path d="M1.87097 3.08694C1.87097 2.53466 2.31869 2.08694 2.87097 2.08694H14.0323V21.913H2.87097C2.31869 21.913 1.87097 21.4653 1.87097 20.913V3.08694Z" fill="#424242" />
            <path d="M30.871 2.08694H43.0323V21.913H30.871V2.08694Z" fill="#424242" />
            <path d="M50.5161 2.08694H55.129C55.6813 2.08694 56.129 2.53466 56.129 3.08694V20.913C56.129 21.4653 55.6813 21.913 55.129 21.913H50.5161V2.08694Z" fill="#424242" />
            <path d="M14.0323 2.08694H22.4516V21.913H14.0323V2.08694Z" fill="white" />
            <path d="M22.4516 2.08694H30.871V21.913H22.4516V2.08694Z" fill="white" />
            <path d="M42.0968 2.08694H50.5161V21.913H42.0968V2.08694Z" fill="white" />
        </svg>

    </div>,
    complexity: 'easy',
    preLoader: 'donut-chart',
    expectedSchema: 'dictionary-array',
    canDragDropFields: true
});